import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../Common/spinner.service';

@Injectable()
export class SelectiveSpinnerInterceptor implements HttpInterceptor {
  private remainingRequestsForResponse = 0;
  
  // APIs that should not show loading spinner
  private excludedUrls = [
    '/api/Webinar/GetTopWebinars',
    '/api/Webinar/GetWebinarRooms',
    '/api/Webinar/GetWebinarImageUrl',
    '/api/Webinar/GetWebinarImageUrls'
  ];

  constructor(
    private spinnerService: SpinnerService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Check if this request should be excluded from spinner
    const shouldShowSpinner = !this.excludedUrls.some(url => request.url.includes(url));
    
    if (shouldShowSpinner) {
      if (this.remainingRequestsForResponse === 0) {
        this.spinnerService.showSpinner();
      }
      this.remainingRequestsForResponse += 1;
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (shouldShowSpinner) {
          this.remainingRequestsForResponse -= 1;
          if (this.remainingRequestsForResponse === 0) {
            this.spinnerService.hideSpinner();
          }
        }
      })
    );
  }
}
